import { render } from "./FrontUnitChooser.vue?vue&type=template&id=99920dee&scoped=true"
import script from "./FrontUnitChooser.vue?vue&type=script&lang=js"
export * from "./FrontUnitChooser.vue?vue&type=script&lang=js"

import "./FrontUnitChooser.vue?vue&type=style&index=0&id=99920dee&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99920dee"]])

export default __exports__